import React from "react";
import { motion } from "framer-motion";
import "./AboutSection.css";
import AboutImg from "../assets/images/about.png";

const AboutSection = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
      <section className="about-section">
        <div className="container">
          {/* Header */}
          <div className="header-about">
            <img
              src={AboutImg}
              alt="SpaceTimeAI Logo"
              className="logo-about"
            />
            <div className="text-content">
              <motion.h2
                initial={{ x: 100 }} 
                whileInView={{ x: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                About SpaceTimeAI
              </motion.h2>
              <motion.p
                initial={{ x: 100 }} 
                whileInView={{ x: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                SpaceTimeAI is a spin-out of the UCL SpaceTimeLab, an interdisciplinary research centre funded in 2012, focusing on developing theory, methods and tools for big data analytics for smart cities; ranked as No.1 GeoComputation Centre in the world.
              </motion.p>
            </div>
          </div>

          <div className="section">
            <motion.h3
              initial={{ x: 100 }} 
              whileInView={{ x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              Track Record
            </motion.h3>
            <motion.p
              initial={{ x: 100 }}
              whileInView={{ x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              Through long-term collaboration with Transport for London (TfL), Public Health England (PHE) and Metropolitan Police Service (MPS), SpaceTimeLab has established a strong track record of turning innovative ideas into actionable solutions for government, built upon the output of £20 million research grants from leading funders and over 250 scientific papers. We have also worked with Arup, Bosh, British Gas, to name a few, and many SMEs to find solutions for their business.
            </motion.p>
          </div>

          <div className="section">
            <motion.h3
              initial={{ x: 100 }} 
              whileInView={{ x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              Capabilities
            </motion.h3>
            <motion.p
              initial={{ x: 100 }} 
              whileInView={{ x: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              Supported by the Lab's leading modelling capability for geo-tagged and time-stamped data analysis, SpaceTimeAI can provide bespoke predictive analytic services and advisory services with tools.
            </motion.p>
          </div>
        </div>
      </section>
    </motion.section>
  );
};

export default AboutSection;